/** The two guest apps one build serves: temporary events (the Selfie App) and permanent events. */
export type GuestMode = 'temporary' | 'permanent'

/**
 * Which app a page gets, from its hostname alone: the hosts listed in `permanentHosts`
 * (VITE_PERMANENT_HOSTS, comma-separated) get the permanent-event app, every other host the
 * temporary-event app. A tenant host (`<service>.<tenant>.gomemo.io`) counts as its service's shared
 * name, so `permanent-dev.mx.gomemo.io` is `permanent-dev.gomemo.io` here: one list for every tenant.
 * `override` (VITE_GUEST_MODE, honoured by the dev server only) wins when set.
 */
export function guestMode(hostname: string, permanentHosts = '', override?: string): GuestMode {
  if (override === 'permanent' || override === 'temporary') return override
  const hosts = permanentHosts.split(',').map((h) => h.trim().toLowerCase())
  const host = hostname.toLowerCase().replace(/^([a-z0-9-]+)\.[a-z0-9-]+\.(gomemo\.io)$/, '$1.$2')
  return host && hosts.includes(host) ? 'permanent' : 'temporary'
}
